module.exports = __webpack_public_path__ + "static/media/icon-specialist.cc0ed019.svg";